export type TClinicBranchSwitchRoute = {
  path: string
  clearQuery: boolean
}

export function resolveClinicRouteAfterBranchSwitch(path: string): TClinicBranchSwitchRoute {
  if (!path.startsWith('/profile-clinic')) {
    return { path: '/profile-clinic/', clearQuery: true }
  }

  if (/^\/profile-clinic\/appointment-[^/]+\/?$/.test(path)) {
    return { path: '/profile-clinic/online-consultations/', clearQuery: true }
  }

  if (/^\/profile-clinic\/applications\/(booking|submission|call)-[^/]+\/?$/.test(path)) {
    return { path: '/profile-clinic/applications/', clearQuery: true }
  }

  if (/^\/profile-clinic\/doctors\/[^/]+\/schedule\/?$/.test(path)) {
    return { path: '/profile-clinic/doctors/schedule/', clearQuery: true }
  }

  if (path.startsWith('/profile-clinic/doctors/new')) {
    return { path: '/profile-clinic/doctors/', clearQuery: true }
  }

  if (path.startsWith('/profile-clinic/doctors/history')) {
    return { path: '/profile-clinic/online-consultations/', clearQuery: true }
  }

  if (path.startsWith('/profile-clinic/doctors/schedule')) {
    return { path: path.endsWith('/') ? path : `${path}/`, clearQuery: true }
  }

  if (path.startsWith('/profile-clinic/partner-programs/') && path !== '/profile-clinic/partner-programs/') {
    return { path: '/profile-clinic/partner-programs/', clearQuery: true }
  }

  if (path.startsWith('/profile-clinic/preview/')) {
    return { path: '/profile-clinic/', clearQuery: true }
  }

  if (path.startsWith('/profile-clinic/finances/payout-')) {
    return { path: '/profile-clinic/finances/', clearQuery: true }
  }

  return { path: path.endsWith('/') ? path : `${path}/`, clearQuery: false }
}
